import { LogoLoader } from '@gokrew/ui';

/** Centered loading indicator shared by every dashboard card's loading state. */
export function CardLoader() {
  return (
    <div className="flex flex-1 items-center justify-center">
      <LogoLoader size="sm" />
    </div>
  );
}
